import React from 'react';

import {Icon} from '@edna/components/primitives';

import {CommonLayout} from 'src/components/primitives';
import Footer from 'src/containers/Footer';
import {LogoImage, LogoTextImage} from 'src/images';

import * as S from './style';

const PulseLogo = () => (
  <S.EdnaLogo>
    <Icon as={LogoImage} size="40px" />
    <LogoTextImage />
  </S.EdnaLogo>
);

export const Layout = React.memo<{children: React.ReactNode}>(({children}) => (
  <CommonLayout>
    <S.Wrapper>
      <S.EdnaImage />
      <S.Form>
        <PulseLogo />
        <React.Suspense fallback={null}>{children}</React.Suspense>
      </S.Form>
    </S.Wrapper>
    <Footer />
  </CommonLayout>
));
